export const UPDATE_ASSESSMENT_ANSWERS = 'UPDATE_ASSESSMENT_ANSWERS';
export const SET_PROCESSING_STATE = 'SET_PROCESSING_STATE';